function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Master",
  stroke: "none",
  strokeWidth: 1.5,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Icons",
  transform: "translate(-120.000000, -318.000000)",
  fill: "currentColor",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "Status-icon/-pending",
  transform: "translate(120.000000, 318.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8,0 C3.58192308,0 0,3.58192308 0,8 C0,12.4180769 3.58192308,16 8,16 C12.4180769,16 16,12.4180769 16,8 C16,3.58192308 12.4180769,0 8,0 Z M11.6923077,9.23076923 L8,9.23076923 C7.66013246,9.23076923 7.38461538,8.95525215 7.38461538,8.61538462 L7.38461538,3.07692308 C7.38461538,2.73705554 7.66013246,2.46153846 8,2.46153846 C8.33986754,2.46153846 8.61538462,2.73705554 8.61538462,3.07692308 L8.61538462,8 L11.6923077,8 C12.0321752,8 12.3076923,8.27551708 12.3076923,8.61538462 C12.3076923,8.95525215 12.0321752,9.23076923 11.6923077,9.23076923 Z",
  id: "Shape"
}))));

var SvgPending = function SvgPending(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPending, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pending.2837a9ec.svg";
export { ForwardRef as ReactComponent };